var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.391 66.5c-22.5-4.5-21.2-61.5 0-61.5",
    stroke: "url(#calculator-arrow_svg__paint0_linear_4164_378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2l16 .857L15.6 17",
    stroke: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calculator-arrow_svg__paint0_linear_4164_378",
    x1: 10.196,
    y1: 5,
    x2: 10.196,
    y2: 66.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5",
    stopOpacity: 0
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iNjkiIHZpZXdCb3g9IjAgMCAyMSA2OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImFycm93Ij4KPHBhdGggaWQ9IlZlY3RvciAzIiBkPSJNMTguMzkxMSA2Ni41Qy00LjEwODkyIDYyIC0yLjgwODg2IDUgMTguMzkxMSA1IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl80MTY0XzM3OCkiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBpZD0iVmVjdG9yIDQiIGQ9Ik0yIDJMMTggMi44NTcxNEwxNS42IDE3IiBzdHJva2U9IiNFNUU1RTUiIHN0cm9rZS13aWR0aD0iNCIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDE2NF8zNzgiIHgxPSIxMC4xOTU2IiB5MT0iNSIgeDI9IjEwLjE5NTYiIHkyPSI2Ni41IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFNUU1RTUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTVFNUU1IiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCalculatorArrow as ReactComponent };